import { render } from "./B2bTablePendingTask.vue?vue&type=template&id=473d9d91&scoped=true&lang=pug"
import script from "./B2bTablePendingTask.vue?vue&type=script&lang=js"
export * from "./B2bTablePendingTask.vue?vue&type=script&lang=js"

import "./B2bTablePendingTask.vue?vue&type=style&index=0&id=473d9d91&lang=scss&scoped=true"
import "./B2bTablePendingTask.vue?vue&type=style&index=1&id=473d9d91&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473d9d91"]])

export default __exports__